<template>
  <div class="only-picturecard">
    <div class="pic-card">
      <div class="pic">
        <img :src="content.picture">
      </div>
      <div class="txt">
        <h4>{{ content.title }}</h4>
        <p>{{ content.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      default: () => ({
        title: '露天農田',
        content:
          '想知道您種的作物什麼時候能夠收成嗎？農園天眼站隨時監測記錄作物積溫、有效光照小時數與更多環境數據，協助您預計產量，並結合氣象預報，避開採收天候不佳，降損增利，讓農產更出眾。',
        picture: 'https://picsum.photos/600/300?random=30',
      }),
    },
  },
  data() {
    return {
      content: this.card,
    };
  },
};
</script>

<style scoped lang="scss">
.only-picturecard {
  height: 100%;
  .pic-card {
    max-width: 500px;
    height: 100%;
    color: #212529;
    background-color: #fff;
    background-color: rgba(219, 219, 219, 0.3);
    color: #fff;
    padding: 20px;
    margin: 2px;
    .pic {
      overflow: hidden;
      border-radius: 5px;
      margin-bottom: 20px;
      img {
        width: 100%;
        height: 200px;
      }
    }
    .txt {
      h4 {
        margin-bottom: 20px;
      }
      p {
        text-align: justify;
        margin: 0;
        font-size: 1rem;
        font-weight: 100;
      }
    }
  }
}
</style>
